import React from 'react';
import './CircularProgress.scss';

interface CircularProgressProps {
  label: string;
  value: number;
  max: number;
}

export const CircularProgress: React.FC<CircularProgressProps> = ({ label, value, max }) => {
  const basePercentage = Math.min((value / max) * 100, 100);
  const overachievementPercentage = value > max ? Math.min(((value - max) / max) * 100, 100) : 0;
  const isGoalReached = value >= max;

  const circumference = 2 * Math.PI * 45;
  const baseStrokeDashoffset = circumference - (basePercentage / 100) * circumference;
  const overachievementStrokeDashoffset =
    circumference - (overachievementPercentage / 100) * circumference;

  return (
    <div className="circular-progress">
      <div className="circular-progress-chart">
        <svg width="120" height="120" className="circular-svg">
          <circle
            cx="60"
            cy="60"
            r="45"
            stroke="#E5E7EB"
            strokeWidth="8"
            fill="none"
            className="circular-bg"
          />
          <circle
            cx="60"
            cy="60"
            r="45"
            stroke="#1A92D0"
            strokeWidth="8"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={baseStrokeDashoffset}
            strokeLinecap="round"
            className="circular-progress-bar circular-progress-base"
            transform="rotate(-90 60 60)"
          />
          {isGoalReached && (
            <circle
              cx="60"
              cy="60"
              r="45"
              stroke="#2BB389"
              strokeWidth="8"
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={overachievementStrokeDashoffset}
              strokeLinecap="round"
              className="circular-progress-bar circular-progress-overachievement"
              transform="rotate(-90 60 60)"
            />
          )}
        </svg>
        <div className="circular-content">
          <span className="circular-value">{value}</span>
          <span className="circular-max">out of {max}</span>
        </div>
      </div>
      <div className="circular-label">{label}</div>
    </div>
  );
};
